<template>
	<div class="flex" style="width: 100%;position: relative;flex-direction: row;align-items: center;">
		<template>
			<el-input type="textarea" :ref="ref" v-model="textareavalue" v-bind="$props" @change="change"></el-input>
		</template>
	</div>

</template>
<style scoped>

</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {

		},
		data() {
			return {
				ref: Math.random(),
				textareavalue:this.value
			}
		},
		created() {


		},
		mounted() {


		},
		watch: {
			value(e){
				this.textareavalue = e
			}
		},
		computed: {

		},
		methods: {

		}
	}
</script>
